import dayjs from 'dayjs';
export class AddToCalendar {
    constructor(options) {

        this.events = options?.events ?? null;
        this.identifier = options.identifier;

        this.init();
    }

    init() {
        var self = this;
        // Remove previous click handlers for this identifier
        $(document).off("click", "#" + self.identifier + " .add-to-calendar");
        $(document).on("click", "#" + self.identifier + " .add-to-calendar", function (e) {
            e.preventDefault();
            e.stopPropagation();

            var calendarType = $(this).data("type");
            var eventId = $(this).data("id");

            switch (calendarType) {
                case "google":
                    self.addToGoogleCalendar(eventId);
                    break;
                case "outlook-online":
                    self.addToOutlookOnlineCalendar(eventId);
                    break;
                default:
                    self.addToOutlookCalendar(eventId);
                    break;
            }
        });
    }

    addEventToList(event) {
        var self = this;

        // if it's the first event added just add it
        if (self.events == null || self.events == undefined || self.events == [null]) {
            self.events = [event];
        } else {

            // if there are already events added to the list, the see if this one is already in there
            var thisEvent = self.events.find(e => e.eventId == event.eventId);

            if (thisEvent == null || thisEvent == undefined) {
                self.events.push(event);
            }
        }

    }

    render(event) {

        var self = this;

        self.addEventToList(event);

        var html = "";

        html += '<div class="add-to-calendar-dropdown">';
        html += '<button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">Add to calendar</button>';
        html += '<div class="dropdown-menu">';
        html += '<a class="dropdown-item add-to-calendar" data-type="outlook" data-id="' + event.eventId + '" href="#">Outlook</a>';
        html += '<a class="dropdown-item add-to-calendar" data-type="google" data-id="' + event.eventId + '" href="#">Google</a>';
        html += '<a class="dropdown-item add-to-calendar" data-type="outlook-online" data-id="' + event.eventId + '" href="#">Outlook Online</a>';
        html += '<a class="dropdown-item add-to-calendar" data-type="outlook" data-id="' + event.eventId + '" href="#">iCalendar</a>';
        html += '</div>';
        html += '</div>';

        return html;
    }

    addToOutlookCalendar(eventId) {
        var self = this;

        var event = self.events.find(e => e.eventId == eventId);

        const now = new Date().toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
        const start = new Date(`${event.startDate} ${event.startTime}`).toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
        const end = new Date(`${event.endDate} ${event.endTime}`).toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
        const uid = `event-${Date.now()}@navigator`;
        const rawDescription = self.escapeICSText(self.stripHtml(event.eventDescription)); // use escaping from earlier

        const icsLines = [
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            'PRODID:-//Navigator//Event Generator//EN',
            'CALSCALE:GREGORIAN',
            'BEGIN:VEVENT',
            `UID:${uid}`,
            `DTSTAMP:${now}`,
            `SUMMARY:${event.eventTitle}`,
            `DESCRIPTION:${self.foldICSLines(rawDescription)}`,
            `LOCATION:${self.formatLocation(event)}`,
            `DTSTART:${start}`,
            `DTEND:${end}`,
            `X-ALT-DESC;FMTTYPE=text/html:<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 3.2//EN"><html><body>${event.eventDescription}</body></html>`,
            'END:VEVENT',
            'END:VCALENDAR'
        ];

        const icsContent = icsLines.join('\r\n'); // Critical: CRLF line endings

        const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `navigator-event-${eventId}.ics`;
        link.click();

    }

    addToGoogleCalendar(eventId) {
        var self = this;

        var event = self.events.find(e => e.eventId == eventId);

        const start = new Date(`${event.startDate} ${event.startTime}`).toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
        const end = new Date(`${event.endDate} ${event.endTime}`).toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';

        const baseUrl = 'https://calendar.google.com/calendar/render?action=TEMPLATE';
        const params = new URLSearchParams({
            text: event.eventTitle,
            details: event.eventDescription,
            location: self.formatLocation(event),
            dates: `${start}/${end}`
        });

        var url = `${baseUrl}&${params.toString()}`;

        window.open(url, "_blank");
    }

    addToOutlookOnlineCalendar(eventId) {
        var self = this;

        var event = self.events.find(e => e.eventId == eventId);

        const start = self.formatOutlookDateTime(event.start);
        const end = self.formatOutlookDateTime(event.end);

        const baseUrl = 'https://outlook.office.com/calendar/0/deeplink/compose?';
        const params = new URLSearchParams({
            subject: event.eventTitle,
            body: event.eventDescription,
            location: self.formatLocation(event),
            startdt: start,
            enddt: end,
            path: '/calendar/action/compose'
        });

        var url = `${baseUrl}${params.toString()}`;

        window.open(url, "_blank");
    }

    stripHtml(html) {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    }

    escapeICSText(text) {
        return text
            .replace(/\\/g, '\\\\')
            .replace(/\n/g, '\\n')
            .replace(/,/g, '\\,')
            .replace(/;/g, '\\;');
    }

    foldICSLines(text) {
        const lines = [];
        let pos = 0;
        while (pos < text.length) {
            let chunk = text.substring(pos, pos + 75);
            if (pos > 0) {
                chunk = ' ' + chunk; // prefix continuation line with space
            }
            lines.push(chunk);
            pos += 75;
        }
        return lines.join('\r\n');
    }

    htmlEncode(str) {
        const replacements = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&apos;'
        };
        return str.replace(/[&<>"']/g, char => replacements[char]);
    }

    formatLocation(event) {

        var location = "";

        if (event.locationName != null && event.locationName != undefined) {
            location += event.locationName;
        }

        if (event.locationAddress1 != null && event.locationAddress1 != undefined) {
            location += " " + event.locationAddress1;
        }

        if (event.locationAddress2 != null && event.locationAddress2 != undefined) {
            location += " " + event.locationAddress2;
        }

        if (event.locationUrl != null && event.locationUrl != undefined) {
            location += " " + event.locationUrl;
        }

        return location;
    }

    formatOutlookDateTime(dateStr) {
        return dayjs(dateStr).toISOString();
    }

}